import React, { Component } from 'react';
import moment from 'moment';
import AuthService from '../services/authService';
import ApiService from '../services/apiService';
import L from '../services/localizationService';
import StorageService from '../services/storageService';

import { CircularProgress } from '@rmwc/circular-progress';
import { DataTable, DataTableContent, DataTableHead, DataTableRow, DataTableHeadCell, DataTableCell, DataTableBody } from '@rmwc/data-table';
import { Button } from '@rmwc/button';
import CurrencyInput from './currencyinput';

class CTCTiming extends Component {

  constructor(props) {
    super(props);

    this.defaultState = {
      isFAM: AuthService.isFAMConfig(),
      projectCostDetailReport: null,
      forecastDate: moment().format('L LT'),
      exchangeRate: L.exchangeRate,

      monthsData: null,
      monthsBalances: null,
      monthlyTotals: null,

      totalEstimatedFinalCost: 0,
      totalCurrentWIP: 0,

      hasCodes: true,
    }

    this.state = {
      project: this.props.project,
      ...Object.assign({}, this.defaultState)
    }

    this._initialLoadComplete = false;
    this.updateReport();
  }

  componentDidMount() {
    if (this.props.project) {
      StorageService.startPolling(this.props.project.ProjNum.trim());
    }

    this._handleBeforeUnload = (e) => {
      // Force-blur the active input to flush any pending CurrencyInput values
      if (document.activeElement) document.activeElement.blur();
      if (StorageService.pendingUpdates()) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', this._handleBeforeUnload);

    this._pollChangeTimer = setInterval(() => {
      let change = StorageService.getExternalChange();
      if (change) {
        StorageService.clearExternalChange();
        if (window.confirm(`This project was updated by ${change.updatedBy}. Reload to see their changes?`)) {
          this.updateReport();
        }
      }
    }, 5000);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this._handleBeforeUnload);
    if (this._pollChangeTimer) clearInterval(this._pollChangeTimer);
    StorageService.stopPolling();
    if (this.state.monthsData && StorageService.hasUnsavedChanges()) {
      this.saveMonthsData(this.state.monthsData);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.project !== prevProps.project) {
      this._initialLoadComplete = false;
      StorageService.startPolling(this.props.project.ProjNum.trim());
      let defaultProps = Object.assign({}, this.defaultState);

      this.setState({
        project: this.props.project,
        ...defaultProps
      }, () => {
          this.updateReport();
        });
    }
  }

  updateReport() {

    L.setExchangeRate(1.00);

    this.setState({
      loadingData: true,
      exchangeRate: 1.00}
    );

    let startingPromise = null;
    if (this.state.isFAM) {
      startingPromise = ApiService.getMexicanExchangeRates()
      .then((rates) => {
        if (rates.length > 0) {
          let rate = rates[0].SellRate;
          console.log('Using MXN SellRate: ', rate);
          L.setExchangeRate(rate)
          this.setState({
            exchangeRate: rate
          });
        }

        return ApiService.getProjectCostDetailReport(this.props.project.ProjNum)
      })
    }
    else {
      startingPromise = ApiService.getProjectCostDetailReport(this.props.project.ProjNum);;
    }

    startingPromise
      .then((projectCostDetailReport) => {
          this.setState( { 
            projectCostDetailReport : projectCostDetailReport
          }, () => {
            this.setupMonths();
          })
      });
  }

  async setupMonths() {
    let monthsData = null;
    let monthsBalances = null;
    let monthlyTotals = null;
    let lineItemCount = this.state.projectCostDetailReport.length;

    let totalEstimatedFinalCost = 0;
    let totalCurrentWIP = 0;

    if (this.state.projectCostDetailReport) {
      monthsData = [];
      this.state.projectCostDetailReport.forEach((item) => {
        totalEstimatedFinalCost += L.parseFloatWithZero(item.EstimatedFinalCost);
        totalCurrentWIP += L.parseFloatWithZero(item.ACost);

        let monthsValues = [];
        for (let j=0; j < 12; j++) {
          monthsValues.push('');
        }
        monthsData.push(monthsValues);
      })
  
      monthsBalances = [];
      for (let i=0; i < lineItemCount+1; i++) {
        let monthsValues = [];
        for (let j=0; j < 2; j++) {
          monthsValues.push(0);
        }
        monthsBalances.push(monthsValues);
      }

      monthlyTotals = [];
      for (let j=0; j < 12; j++) {
        monthlyTotals.push(0);
      }

    }

    await this.restoreMonthsData(monthsData);
    
    this.setState( { 
      monthsData: monthsData,
      monthsBalances: monthsBalances,
      monthlyTotals: monthlyTotals,
      totalEstimatedFinalCost: totalEstimatedFinalCost,
      totalCurrentWIP: totalCurrentWIP,
      hasCodes: (this.state.projectCostDetailReport && this.state.projectCostDetailReport.length > 0)
    }, () => {
      this.recalcTotals();
      this._initialLoadComplete = true;
    });
  }

  clearMonths() {
    // Blank out the data for all the months
    let monthsData = this.state.monthsData;
    for (let i=0; i < monthsData.length; i++) {
      for (let j=0; j < monthsData[i].length; j++) {
        monthsData[i][j] = '';
      }
    }

    this.setState( { 
      monthsData: monthsData,
    }, () => {
      this.recalcTotals();
    })
  }

  changeMonthData(value, costCodeIdx, monthIdx) {

    let monthsData = this.state.monthsData;
    monthsData[costCodeIdx][monthIdx] = value;

    this.setState({ 
      monthsData : monthsData,
    })
  }

  recalcTotals() {
    let lineCodeCount = this.state.projectCostDetailReport.length;
    for (let i=0; i < lineCodeCount; i++) {
      for (let j=0; j < 12; j++) {
        this.recalcTotal(i, j, true);
      }
    }
    this.recalcTotal(0, 0, false);
  }

  recalcTotal(costCodeIdx, monthIdx, deferUpdate) {
    let monthsData = this.state.monthsData;
    let lineCodeCount = this.state.projectCostDetailReport.length;
    let theItem = this.state.projectCostDetailReport[costCodeIdx];
    let balancesData = this.state.monthsBalances;

    let newMonthsTotal = 0;
    if (monthsData[costCodeIdx]) {
      monthsData[costCodeIdx].forEach((monthAmt) => newMonthsTotal += L.parseFloatWithZero(monthAmt));
    }

    let monthlyTotals = this.state.monthlyTotals;
    monthlyTotals[monthIdx] = 0;
    this.state.projectCostDetailReport.forEach((item, idx) => monthlyTotals[monthIdx] += L.parseFloatWithZero(monthsData[idx][monthIdx]))
    
    let newBalance = 0;
    if (theItem) {
      newBalance = L.parseFloatWithZero(theItem.EstimatedFinalCost) - L.parseFloatWithZero(theItem.ACost) - newMonthsTotal;
    }

    balancesData[costCodeIdx][0] = newMonthsTotal;
    balancesData[costCodeIdx][1] = newBalance;

    balancesData[lineCodeCount][0] = 0;
    balancesData[lineCodeCount][1] = 0;
    for (let i=0; i < lineCodeCount; i++) {
      balancesData[lineCodeCount][0] += balancesData[i][0];
      balancesData[lineCodeCount][1] += balancesData[i][1] 
    }

    if (!deferUpdate) {
      this.setState({ 
        monthsBalances: balancesData,
        monthlyTotals: monthlyTotals
      })

      if (this.props.onExportDataset) {
        this.props.onExportDataset(this.state);
      }

      if (this._initialLoadComplete) {
        this.saveMonthsData(monthsData);
      }
    }
  }

  getCookieName() {
    return `md${this.props.project.ProjNum.trim()}`;
  }

  restoreMonthsData(monthsData) {
    return new Promise((resolve, reject) => {
      StorageService.restoreData(this.props.project.ProjNum).then((dashboardData) => {
        if (dashboardData && dashboardData.ctcTiming) {
          try {
            let restoredData = dashboardData.ctcTiming;

            restoredData.forEach((monthlyDataItem) => {
              let rowIdx = this.state.projectCostDetailReport.findIndex(item => item.CostCode === monthlyDataItem.costcode);
              if (rowIdx > -1) {
                monthsData[rowIdx] = monthlyDataItem.monthsData.slice();
              }
              else {
                console.info(`Code code ${monthlyDataItem.costcode} no longer exists`)
              }
            })

            console.info(`Restored existing data for project ${this.props.project.ProjNum}`)
          }
          catch (err) {
            console.error('Data store is corrupted - resetting', err);
            StorageService.clearData(this.props.project.ProjNum);
          }
          resolve();
        }
        else {
          console.info(`No existing data for project ${this.props.project.ProjNum}`)
          resolve();
        }
      })
    })
  }

  saveMonthsData(monthsData) {
    // We need to store the Cost Codes against the rows in case they are different when the data is
    // restored at a later time
    let data = [];
    this.state.projectCostDetailReport.forEach((item, idx) => {
      data.push({
        costcode: item.CostCode,
        monthsData: monthsData[idx]
      })
    })

    StorageService.saveCTCTimingData(data);
  }

  handleOnClearSheet() {
    if (window.confirm('Clear the sheet and start over?')) {
      this.clearMonths();
    }
  }

  renderTable() {
    if (this.state.projectCostDetailReport && this.state.monthsData && this.state.monthsBalances) {
      let tableContent = null;
      let lineCodeCount = this.state.projectCostDetailReport.length;

      let monthHeaders = [];
      for (let i=0; i < 12; i++) {
        monthHeaders.push(<DataTableHeadCell className="tight el-boldo" alignMiddle key={`ctc_timing_head_cell_${i}`}>
          {moment().add(i, 'months').format('MMM')}
          </DataTableHeadCell>)
      }

      let monthInputs = [];
      for (let i=0; i < this.state.projectCostDetailReport.length; i++) {
        let theInputs = [];
        for (let j=0; j < 12; j++) {
          theInputs.push(<DataTableCell key={`month_cell_${i}_${j}`} className="tight">
            <CurrencyInput key={`month${i}_${j}`} value={this.state.monthsData[i][j]} 
              onChanged={(newValue) => {this.changeMonthData(newValue, i,j); this.recalcTotal(i,j);}}>
            </CurrencyInput></DataTableCell>)
        }
        monthInputs.push(theInputs);
      }

      let monthlyTotalsCells = [];
      for (let j=0; j < 12; j++) {
        monthlyTotalsCells.push(<DataTableCell className="tight" key={`month_total_cell_${j}`}>
          {L.toCurrencyString(this.state.monthlyTotals[j])}
          </DataTableCell>);
      }
    
      tableContent = this.state.projectCostDetailReport.map((item, index) => {
        return <DataTableRow key={index}>
          <DataTableCell>{item.CostCode}</DataTableCell>
          <DataTableCell>{item.WMS_DerCostCodeDescription}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(L.parseFloatWithZero(item.EstimatedFinalCost))}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(L.parseFloatWithZero(item.ACost))}</DataTableCell>
          {monthInputs[index]}
          <DataTableCell>{L.toCurrencyString(this.state.monthsBalances[index][0])}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(this.state.monthsBalances[index][1])}</DataTableCell>
        </DataTableRow>;
      });

      tableContent.push(<DataTableRow className="el-boldo" key={lineCodeCount}>
        <DataTableCell></DataTableCell>
        <DataTableCell></DataTableCell>
        <DataTableCell>{L.toCurrencyString(this.state.totalEstimatedFinalCost)}</DataTableCell>
        <DataTableCell>{L.toCurrencyString(this.state.totalCurrentWIP)}</DataTableCell>
        {monthlyTotalsCells}
        <DataTableCell>{L.toCurrencyString(this.state.monthsBalances[lineCodeCount][0])}</DataTableCell>
        <DataTableCell>{L.toCurrencyString(this.state.monthsBalances[lineCodeCount][1])}</DataTableCell>
      </DataTableRow>);

      let pageBody = null;
      if (this.state.hasCodes) {
        pageBody = <>
        <DataTable className="ctc-timing-table">
            <DataTableContent>
              <DataTableHead>
                <DataTableRow>
                  <DataTableHeadCell className="el-boldo" alignMiddle>Cost<br/>Code</DataTableHeadCell>
                  <DataTableHeadCell className="el-boldo" alignMiddle>Description</DataTableHeadCell>
                  <DataTableHeadCell className="el-boldo" alignMiddle>Estimated Final<br/>Cost</DataTableHeadCell>
                  <DataTableHeadCell className="el-boldo" alignMiddle>Current<br/>WIP</DataTableHeadCell>
                  {monthHeaders}
                  <DataTableHeadCell className="el-boldo" alignMiddle>TOTAL</DataTableHeadCell>
                  <DataTableHeadCell className="el-boldo" alignMiddle>Balance</DataTableHeadCell>
                </DataTableRow>
              </DataTableHead>

              <DataTableBody>

              {tableContent}

            </DataTableBody>
          </DataTableContent>
        </DataTable>

        {/* <div className="bottom-buttons">
          <Button raised label="Clear Sheet" onClick={() => this.handleOnClearSheet()} />
        </div> */}
        </>;
      }
      else  {
        pageBody = <div style={{textAlign: "center", marginTop: "15px"}}>No lines items for this project.</div>;
      }

      return <>
            <div className="dashboard-top content-max-width">
            <div className="dashboard-top-header">
              <label>Project #:</label>{this.props.project.ProjNum.trim()}<br/>
              <label>Proj. Mgr.:</label>{this.props.project.ProjMgr}
            </div>
            <div className="forecast-date-section">
              <label>Forecast Date:</label>{this.state.forecastDate}<br/>
              {/* { this.state.isFAM ? <div><label>MXN Rate:</label>{this.state.exchangeRate}</div> : null } */}
            </div>
          </div>

          {pageBody}
        </>
    }

    return <div style={{textAlign: 'center', marginTop: "15px"}}>Loading details...<br/><CircularProgress /></div>
  }
    
  render() {
      return <div className="ctc-timing">
        {this.renderTable()}
    </div>
  }
}

export default CTCTiming;
